<template>
  <div class="form-group">
    <label for="ProductCategorySelect" v-if="label">{{ label }}</label>
    <select
      :value="value"
      v-on="listeners"
      @input="updateValue"
      v-bind="$attrs"
      class="form-control"
      id="ProductCategorySelect"
    >
      <!-- v-on="$listeners" is MISSING in select element-->

      <option
        v-for="option in options"
        :key="option"
        :selected="option === value"
        >{{ option }}</option
      >
    </select>
  </div>
</template>

<script>
import { formFieldMixin } from '@/mixins/formFieldMixin'

export default {
  mixins: [formFieldMixin],
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue
      }
    }
  }
}
</script>

<style></style>
